var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.numberFormatted(_vm.value)))])],null,{ item: _vm.item, value: _vm.value })],2)}
var staticRenderFns = []

export { render, staticRenderFns }